import http from "./http";

export const getDashboardData = async () => {
  const res = await http.get("dashboard");
  return res.data;
};
